import * as React from "react";

export function renderUrl (url: string, label: string, selectClass?: string, rowClass?: string, showLabel = true) {
    let href;
    if (validateEmail(url)) {
        href = `mailto:${url}`
    } else if (validateUrl(url)) {
        href = `${url}`
    } else {
        href = `http://${url}`;
    }
    return (
        <>
            {url && url !== '.Unknown' && url !== 'null' &&
            <div className={rowClass}>
                {showLabel && <b>{label}: </b>}<a className={selectClass} rel="noreferrer" target={'_blank'} href={href}>{url}</a>
            </div>}
            {url && url === '.Unknown' &&
            <div className={rowClass}>
                {showLabel && <b>{label}: </b>}<span className={selectClass}>{url}</span>
            </div>}
        </>
    )
}

function validateUrl (url: string) {
    const re = /^(http|https):\/\//;
    return re.test(url);
}

function validateEmail (email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
